import React, { useState } from 'react';

import { useScroll } from '../../hook/useScroll';
import CustomIcon from '../custom_icon/custom_icon';
import PromoPopup from '../../components/promo_popup/promo_popup';

//import { clickAlimtalk, onKakaoClick } from '../../common/sendLog';

import styles from './fixed_btns.module.css';

const TopButton = ({ isMain }) => {
  const { scrollY } = useScroll();

  const [promoOpen, setPromoOpen] = useState(false);
  /* const onPromoClick = (e) => {
    e.preventDefault();

    setPromoOpen(true);
    clickAlimtalk();
  }; */

  const scrollToNextSection = () => {
    window.scroll({
      top: window.innerHeight,
      left: 0,
      behavior: 'smooth',
    });
  };

  const scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const goToScrollView = () => {
    scrollY >= window.innerHeight ? scrollToTop() : scrollToNextSection();
  };

  return (
    <>
      {/* <div
        onClick={() => onKakaoClick('layout')}
        className={`${isMain && scrollY <= 400 && styles.invisible} ${
          styles.button
        } ${styles.kakaoBtn}`}
      >
        카카오톡 상담신청
      </div> */}

      {/* side */}
      <div className={styles.sideBtns}>
        {/* <div onClick={goToPG} className={styles.pgBtn}>
          총알 입금
        </div>

        <div onClick={goToAgency} className={styles.agencyBtn}>
          대리점 모집
        </div> */}

        <div onClick={goToScrollView} className={styles.topBtn}>
          <div
            className={styles.icon}
            style={{
              transform:
                scrollY >= window.innerHeight ? 'rotate(180deg)' : 'none',
            }}
          >
            <CustomIcon icon='arrow' color='#e0e0e0' />
          </div>
        </div>
      </div>

      {promoOpen && <PromoPopup setPromoOpen={setPromoOpen} />}
    </>
  );
};

export default TopButton;
